import { faEnvelope, faEnvelopeOpen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import React from 'react';

import style from './SentItem.style';
import './SentItem.style.css';

const SentItem = ({ sentItem, selectedSentItem, setSelectedSentItem, onClick, columnSentItems, isDark }) => {
  const { isOpened, Subject, DateSent, FirstName, LastName, index } = sentItem;
  const isSelectedItem =
    selectedSentItem && selectedSentItem.pk_CommunicationHistory === sentItem.pk_CommunicationHistory;
  const backgroundClass = index % 2 === 0 ? 'is-even' : 'is-odd';

  return (
    <div
      className={`sent-item-row ${backgroundClass}${isSelectedItem ? ' is-selected' : ''}${isDark ? ' is-dark' : ''}`}
      style={style.mainContainer}
      onClick={() => {
        setSelectedSentItem(sentItem);
        if (onClick) {
          onClick();
        }
      }}
    >
      <div className="sent-item-icon-wrap" style={{ ...style.simpleColumn }}>
        <FontAwesomeIcon icon={isOpened ? faEnvelopeOpen : faEnvelope} className="sent-item-icon" />
      </div>
      <div className="sent-item-content" style={{ ...style.simpleColumn, width: columnSentItems ? '100%' : 'calc(100% - 60px)' }}>
        {columnSentItems ? (
          <div className="sent-item-grid" style={{ ...style.simpleRow }}>
            <div className="sent-item-grid-col" style={{ ...style.simpleColumn }}>
              <div style={style.dateLabel}>{DateSent ? dayjs(DateSent).format('MM/DD/YYYY hh:mm A') : 'No Date'}</div>
            </div>
            <div className="sent-item-grid-col" style={{ ...style.simpleColumn }}>
              <div style={style.minorText}>{Subject || '(No Subject)'}</div>
            </div>
            <div className="sent-item-grid-col" style={{ ...style.simpleColumn }}>
              <div style={style.minorText}>{`${LastName}, ${FirstName}`}</div>
            </div>
          </div>
        ) : (
          <>
            <div style={style.dateLabel}>{DateSent ? dayjs(DateSent).format('MM/DD/YYYY hh:mm A') : 'No Date'}</div>
            <div className="sent-item-subject" style={style.minorText}>
              {Subject || '(No Subject)'}
            </div>
            <div className="sent-item-recipient" style={style.minorText}>{`${LastName}, ${FirstName}`}</div>
          </>
        )}
      </div>
    </div>
  );
};

export default SentItem;
